import { Manuscript } from './manuscript';
import { BiblioRecord } from './biblio-record';

export class CeReference {
    private _linkId: string;
    private _label: string;
    private _data: Manuscript | BiblioRecord;

    constructor(linkId: string = '', label: string = '', data: Manuscript | BiblioRecord = null) {
        this._linkId = linkId;
        this._label = label;
        this._data = data;
    }

    /* Reference linkId */
    set linkId(value: string) {
        if (value) {
            this._linkId = value;
        } else {
            this._linkId = '';
        }
    }

    get linkId(): string {
        return this._linkId;
    }

    /* Reference label */
    set label(value: string) {
        if (value) {
            this._label = value;
        } else {
            this._label = '';
        }
    }

    get label(): string {
        return this._label;
    }

    /* Reference data object */
    set data(value: Manuscript | BiblioRecord) {
        if (value) {
            this._data = value;
        } else {
            this._data = null;
        }
    }

    get data(): Manuscript | BiblioRecord {
        return this._data;
    }

}

export type CeReferenceList = Array<CeReference>;



// WEBPACK FOOTER //
// ./src/app/models/ce-reference.ts